export const hasError = meta => {
  return Boolean(meta.touched && !!meta.error);
};
